import React, { useEffect } from 'react';
import 'weui';
import 'react-weui/build/packages/react-weui.css';
import wx from 'wx';
import { history } from 'umi';
import { getAreaCode, getConfig } from '@/services/js_sdk';
import { isLocalServer, setAuthRedirect, updateShareInfo, setAreaCode } from '@/utils/utils';
import { updateUserLocation } from '@/utils/wechat';

const updateWxConfig = () => {
  if (!isLocalServer()) {
    updateShareInfo({});
    getConfig({
      url: window.location.href
    }).then(res => {
      if (res && res.code === 200) {
        const { data } = res;
        wx.config({
          debug: false,
          ...data,
          jsApiList: [
            'getLocation',
            'updateAppMessageShareData',
            'updateTimelineShareData',
          ],
          openTagList: [
            'wx-open-launch-weapp',
          ],
        });
      }
    });
  }
}

const BlankComponent = (props) => {
  const { children } = props;

  useEffect(() => {

    if("/auth" !== location.pathname) {
      setAuthRedirect(window.location.href);
    }

    wx.ready(() => updateUserLocation({
      success: () => {}
    }));

    updateWxConfig();

    history.listen((location, action) => {
      updateWxConfig();
    });

  }, []);

  return (
    <>
      {children}
    </>
  );
}

export default BlankComponent;
